export default {
  NAVIGATION_LOAD: Symbol('NAVIGATION_LOAD'),
  NAVIGATION_TOGGLE_NAVIGATOR_TREE_NODE: Symbol(
    'NAVIGATION_TOGGLE_NAVIGATOR_TREE_NODE'
  ),
  NAVIGATION_TOGGLE_BASKET_TREE_NODE: Symbol(
    'NAVIGATION_TOGGLE_BASKET_TREE_NODE'
  ),
};
